module.exports = __webpack_public_path__ + "img/4.c34c4c77.jpg";